import React from "react";
import GameInstructionModal from "./GameInstructionModal";

const ModalMatchGabor = ({ isOpen, onRequestClose }) => {
  return (
    <GameInstructionModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      title="Match Gabor"
      gamePath="/userDashboard/game/match-gabor"
      icon="solar:grid-bold"
      instructions={[
        "Drag and drop/swap adjacent circles to align three or more of the same design in a row or column.",
        "Clear matching sets to score points before time runs out."
      ]}
      isBinocular={false}
    />
  );
};

export default ModalMatchGabor;
